import DateHelper from './date_helper';

export default class ApiRequestHelper {
  static buildV3EligibilityData({ eligibilityFormData }) {
    eligibilityFormData = {
      applicantSignature: eligibilityFormData.applicantSignature,
      cssn:
        eligibilityFormData.cssn &&
        eligibilityFormData.cssn.substr(0, 3) +
          '-' +
          eligibilityFormData.cssn.substr(3, 2) +
          '-' +
          eligibilityFormData.cssn.substr(5, 4),
      cdob: eligibilityFormData.cdob && DateHelper.convertUsToIsoDate(eligibilityFormData.cdob),
      cgrossannualincome: eligibilityFormData.cgrossannualincome,

      coapplicantSignature: eligibilityFormData.csecondaryemail,
      csecondaryssn:
        eligibilityFormData.csecondaryssn &&
        eligibilityFormData.csecondaryssn.substr(0, 3) +
          '-' +
          eligibilityFormData.csecondaryssn.substr(3, 2) +
          '-' +
          eligibilityFormData.csecondaryssn.substr(5, 4),
      csecondarydob:
        eligibilityFormData.csecondarydob && DateHelper.convertUsToIsoDate(eligibilityFormData.csecondarydob),
      csecondarygrossannualincome: eligibilityFormData.csecondarygrossannualincome,
      cowner: eligibilityFormData.cowner,
      cresident: eligibilityFormData.cresident,
      csecondaryowner: eligibilityFormData.csecondaryowner,
      csecondaryresident: eligibilityFormData.csecondaryresident,
    };
    if (['null', null, undefined].includes(eligibilityFormData.cowner)) {
      delete eligibilityFormData.cowner;
      delete eligibilityFormData.cresident;
    }
    if (['null', null, undefined].includes(eligibilityFormData.csecondaryowner)) {
      delete eligibilityFormData.csecondaryowner;
      delete eligibilityFormData.csecondaryresident;
    }
    return eligibilityFormData;
  }

  static buildEligibilityData({ customerFormData, eligibilityFormData }) {
    // Assumption : secondary and primary homeowner's live at the same address
    eligibilityFormData.csecondaryfirstname = customerFormData.csecondaryfirstname;
    eligibilityFormData.csecondarylastname = customerFormData.csecondarylastname;
    eligibilityFormData.csecondaryphone = customerFormData.csecondaryphone;
    eligibilityFormData.csecondaryemail = customerFormData.csecondaryemail;

    eligibilityFormData.csecondaryaddress1 = customerFormData.caddress1;
    eligibilityFormData.csecondarycity = customerFormData.ccity;
    eligibilityFormData.csecondarystate = customerFormData.cstate;
    eligibilityFormData.csecondaryzip = customerFormData.czip;

    eligibilityFormData.csecondaryaddress1_mail = customerFormData.caddress1Mail || customerFormData.caddress1;
    eligibilityFormData.csecondarycity_mail = customerFormData.ccityMail || customerFormData.ccity;
    eligibilityFormData.csecondarystate_mail = customerFormData.cstateMail || customerFormData.cstate;
    eligibilityFormData.csecondaryzip_mail = customerFormData.czipMail || customerFormData.czip;

    eligibilityFormData.cssn =
      eligibilityFormData.cssn &&
      eligibilityFormData.cssn.substr(0, 3) +
        '-' +
        eligibilityFormData.cssn.substr(3, 2) +
        '-' +
        eligibilityFormData.cssn.substr(5, 4);
    eligibilityFormData.csecondaryssn =
      eligibilityFormData.csecondaryssn &&
      eligibilityFormData.csecondaryssn.substr(0, 3) +
        '-' +
        eligibilityFormData.csecondaryssn.substr(3, 2) +
        '-' +
        eligibilityFormData.csecondaryssn.substr(5, 4);

    eligibilityFormData.cdob = eligibilityFormData.cdob && DateHelper.convertUsToIsoDate(eligibilityFormData.cdob);
    eligibilityFormData.csecondarydob =
      eligibilityFormData.csecondarydob && DateHelper.convertUsToIsoDate(eligibilityFormData.csecondarydob);

    if (!eligibilityFormData.jointApplication) {
      eligibilityFormData.csecondaryfirstname = undefined;
      eligibilityFormData.csecondarylastname = undefined;

      eligibilityFormData.csecondaryphone = undefined;
      eligibilityFormData.csecondaryssn = undefined;
      eligibilityFormData.csecondarydob = undefined;
      eligibilityFormData.secondaryhomeowner_identification_issued_by_state = undefined;
      eligibilityFormData.csecondarycurrentoccupation = undefined;
      eligibilityFormData.csecondarygrossannualincome = undefined;

      eligibilityFormData.csecondaryaddress1 = undefined;
      eligibilityFormData.csecondarycity = undefined;
      eligibilityFormData.csecondarystate = undefined;
      eligibilityFormData.csecondaryzip = undefined;

      eligibilityFormData.csecondaryaddress1_mail = undefined;
      eligibilityFormData.csecondarycity_mail = undefined;
      eligibilityFormData.csecondarystate_mail = undefined;
      eligibilityFormData.csecondaryzip_mail = undefined;
    }

    if (eligibilityFormData.jointApplication) {
      eligibilityFormData.csecondarycurrentoccupation = 0; // Hardcoding data as requested, since these fields are removed
      eligibilityFormData.csecondarylengthofemployment = 0;
    }

    return {
      ...eligibilityFormData,
      czip: customerFormData.czip,
      cphone1: customerFormData.cphone1,
      ccity: customerFormData.ccity,
      caddress1: customerFormData.caddress1,
      cstate: customerFormData.cstate,
      cfirstname: customerFormData.cfirstname,
      clastname: customerFormData.clastname,
      cemail: customerFormData.cemail,
      cresidencetype: 'OWN',
      ccurrentoccupation: 0,
      clengthofemployment: 0,
      cyearsatresidence: 0,
      cmonthlymortgage: 0,
      homeowner_identification_issued_by_state: 'AL',
      homeowner_identification_number: 0,
      cterms1: true,
      caddress1_mail: customerFormData.caddress1Mail || customerFormData.caddress1,
      czip_mail: customerFormData.czipMail || customerFormData.czip,
      ccity_mail: customerFormData.ccityMail || customerFormData.ccity,
      cstate_mail: customerFormData.cstateMail || customerFormData.cstate,

      // Guarantor
      cguarantorAddress1: customerFormData.cguarantorAddress1,
      cguarantorAddress2: customerFormData.cguarantorAddress2,
      cguarantorState: customerFormData.cguarantorState,
      cguarantorCity: customerFormData.cguarantorCity,
      cguarantorZip: customerFormData.cguarantorZip,
      cguarantorPhone: customerFormData.cguarantorPhone,

      cphone1smsOptIn: customerFormData.cphone1smsOptIn,
      csecondaryPhoneSmsOptIn: customerFormData.csecondaryPhoneSmsOptIn,
    };
  }

  static buildCheckTitleEligibilityData({ customerFormData, eligibilityFormData }) {
    eligibilityFormData.csecondaryfirstname = customerFormData.csecondaryfirstname;
    eligibilityFormData.csecondarylastname = customerFormData.csecondarylastname;
    eligibilityFormData.csecondaryphone = customerFormData.csecondaryphone;
    eligibilityFormData.csecondaryemail = customerFormData.csecondaryemail;

    // Assumption : secondary and primary homeowner's live at the same address
    eligibilityFormData.csecondaryaddress1 = customerFormData.caddress1;
    eligibilityFormData.csecondarycity = customerFormData.ccity;
    eligibilityFormData.csecondarystate = customerFormData.cstate;
    eligibilityFormData.csecondaryzip = customerFormData.czip;

    eligibilityFormData.csecondaryaddress1_mail = customerFormData.caddress1Mail || customerFormData.caddress1;
    eligibilityFormData.csecondarycity_mail = customerFormData.ccityMail || customerFormData.ccity;
    eligibilityFormData.csecondarystate_mail = customerFormData.cstateMail || customerFormData.cstate;
    eligibilityFormData.csecondaryzip_mail = customerFormData.czipMail || customerFormData.czip;

    eligibilityFormData.cssn =
      eligibilityFormData.cssn &&
      eligibilityFormData.cssn.substr(0, 3) +
        '-' +
        eligibilityFormData.cssn.substr(3, 2) +
        '-' +
        eligibilityFormData.cssn.substr(5, 4);
    eligibilityFormData.csecondaryssn =
      eligibilityFormData.csecondaryssn &&
      eligibilityFormData.csecondaryssn.substr(0, 3) +
        '-' +
        eligibilityFormData.csecondaryssn.substr(3, 2) +
        '-' +
        eligibilityFormData.csecondaryssn.substr(5, 4);

    eligibilityFormData.cdob = eligibilityFormData.cdob && DateHelper.convertUsToIsoDate(eligibilityFormData.cdob);
    eligibilityFormData.csecondarydob =
      eligibilityFormData.csecondarydob && DateHelper.convertUsToIsoDate(eligibilityFormData.csecondarydob);

    if (eligibilityFormData.jointApplication) {
      eligibilityFormData.csecondarycurrentoccupation = 0; // Hardcoding data as requested, since these fields are removed
      eligibilityFormData.csecondarylengthofemployment = 0;
    }

    return {
      ...eligibilityFormData,
      czip: customerFormData.czip,
      cphone1: customerFormData.cphone1,
      ccity: customerFormData.ccity,
      caddress1: customerFormData.caddress1,
      cstate: customerFormData.cstate,
      cfirstname: customerFormData.cfirstname,
      clastname: customerFormData.clastname,
      cemail: customerFormData.cemail,
      cresidencetype: 'OWN',
      ccurrentoccupation: 0,
      clengthofemployment: 0,
      cyearsatresidence: 0,
      cmonthlymortgage: 0,
      homeowner_identification_issued_by_state: 'AL',
      homeowner_identification_number: 0,
      cterms1: true,
      caddress1_mail: customerFormData.caddress1Mail || customerFormData.caddress1,
      czip_mail: customerFormData.czipMail || customerFormData.czip,
      ccity_mail: customerFormData.ccityMail || customerFormData.ccity,
      cstate_mail: customerFormData.cstateMail || customerFormData.cstate,

      // Guarantor
      cguarantorAddress1: customerFormData.cguarantorAddress1,
      cguarantorAddress2: customerFormData.cguarantorAddress2,
      cguarantorState: customerFormData.cguarantorState,
      cguarantorCity: customerFormData.cguarantorCity,
      cguarantorZip: customerFormData.cguarantorZip,
      cguarantorPhone: customerFormData.cguarantorPhone,
    };
  }

  static customerDataFormFields(isResidential) {
    const guarantorFields = [
      'cguarantorAddress1',
      'cguarantorAddress2',
      'cguarantorState',
      'cguarantorCity',
      'cguarantorZip',
      'cguarantorPhone',
    ];
    let r = [
      'caddress1',
      'czip',
      'ccity',
      'caddress1Mail',
      'caddress2Mail',
      'ccityMail',
      'cstateMail',
      'czipMail',
      'creditCheckType',
    ];
    const personal = [
      'cfirstname',
      'clastname',
      'cemail',
      'cbusinessName',
      'cbusinessTitle',
      'cphone1',
      'cphone1smsOptIn',
    ];
    const coapp = [
      'csecondaryfirstname',
      'csecondarylastname',
      'csecondaryphone',
      'csecondaryemail',
      'csecondaryssn',
      'csecondarydob',
      'secondaryhomeowner_identification_issued_by_state',
      'csecondarycurrentoccupation',
      'csecondarygrossannualincome',
      'csecondaryaddress1',
      'csecondarycity',
      'csecondarystate',
      'csecondaryzip',
      'csecondaryaddress1_mail',
      'csecondarycity_mail',
      'csecondarystate_mail',
      'csecondaryzip_mail',
      'csecondaryemail',
      'csecondaryPhoneSmsOptIn',
    ];

    if (!isResidential) {
      r = r.concat(guarantorFields);
    }
    return r.concat(personal).concat(coapp);
  }

  static buildCustomerFormData(customer, fields) {
    if (!fields) {
      fields = this.customerDataFormFields(true);
    }
    let customerFormData = {};
    fields.forEach((key) => {
      if (typeof customer[key] !== 'undefined') {
        customerFormData[key] = customer[key];
      }
    });
    return customerFormData;
  }

  static compareCustomerDataFormData(customer, formData, isResidential) {
    return (
      JSON.stringify(this.buildCustomerDataFormData(formData, isResidential)) ===
      JSON.stringify(this.buildCustomerDataFormData(customer, isResidential))
    );
  }

  static buildCustomerDataFormData(customer, isResidential) {
    return this.buildCustomerFormData(customer, this.customerDataFormFields(isResidential));
  }
}
